import { Square } from '../../../../../shared/components/utility/square/Square'
import { Outlet } from 'react-router-dom'
import { Header } from './ui/Header'
import { Footer } from './ui/Footer'

export const TopMenuLayout = () => {
  return (
    <div className={'flex min-h-screen flex-col bg-[#F8FAFE]'}>
      <div className={'-mb-[88px] bg-focus-500 pb-[88px]'}>
        <div
          className={
            'relative z-20 mx-auto px-[16px] pt-[16px] md:container xl:max-w-[1440px] xl:pt-0 xxl:max-w-[1920px]'
          }
        >
          <Header />
        </div>
      </div>
      <div
        className={
          'relative z-10 mx-auto flex w-full flex-1 pt-[16px] md:container md:px-[16px] xl:max-w-[1440px] xl:pt-0 xxl:max-w-[1920px]'
        }
      >
        <Square className={'flex w-full flex-col p-[16px] xl:p-[32px]'} depth='100'>
          <Outlet />
        </Square>
      </div>
      <div className={'-mt-[102px] min-h-[184px] bg-focus-500 pt-[102px]'}>
        <div className={'md:container md:px-[16px] xl:max-w-[1440px] xl:pt-0 xxl:max-w-[1920px]'}>
          <Footer />
        </div>
      </div>
    </div>
  )
}
